<template>
  <router-link to="status"
               class="branding">
    <div class="d-flex flex-row align-center">
      <img class="corporation-logo"
           v-if="corporationLogoUrl"
           v-bind:src="corporationLogoUrl"
           alt="logo"
           aria-hidden="true">
      <img class="abc-maintenance-symbol"
           src="@/assets/favicon.png"
           alt="logo"
           aria-hidden="true"/>
      <div class="abc-maintenance-app-name">ABC Maintenance</div>
    </div>
  </router-link>
</template>
<script>
export default {
  name: 'BrandingLogo',
  computed: {
    corporationLogoUrl() {
      return this.$store.getters['corporationSettingsState/logoUrl'];
    },
  },
};
</script>

<style scoped>

.branding {
  white-space: nowrap;
  overflow: hidden;
  text-decoration: none;
  color: black;
}

.abc-maintenance-symbol {
  max-height: 40px;
  height: 100%;
  width: auto;
}

.abc-maintenance-app-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}

img.corporation-logo {
  max-height: 40px;
  height: 100%;
  width: auto;
  margin-left: 1em;
}

</style>
